module.exports = __webpack_public_path__ + "img/exchange-divide.d5a286e9.svg";